import { CHANGE_SEAT_LAYOUT_URL } from "../../utils/api-url";
import { postCall } from "../../utils/network.util";

// seatMapping is {oldSeatNumber: newSeatNumber} for the occupied seats only; the
// server reads every other detail (status, blocked info, genders, reservations)
// from its own tables inside the change transaction, so no seat data snapshot is
// sent from the client any more.
export const changeSeatLayoutReq=(tripId , newBusId, seatMapping, scheduleParams, sendNotification, onSuccess=()=>{},onFailure=()=>{})=>{
    postCall(CHANGE_SEAT_LAYOUT_URL,{
        tripId , newBusId ,seatMapping, updatedBy:global.userName, scheduleParams, sendNotification
    })
    .then((findresponce) =>
      {
        if(findresponce.status === "SUCCESS" && findresponce.payload.Status === "SUCCESS"){
           onSuccess(findresponce.payload.Payload);
         }else{
            onFailure(findresponce.payload.Message);
         }
      })
}
